'use client';
import { isValidStyleProperty } from '../../../core/utilities/swan-style.utils.js';
import { className } from '../../../core/utilities/classnames.utils.js';
import { iterToSet } from '../../../core/utilities/transform.utils.js';
import { processStyleProps } from '../../../core/utilities/swan-style.js';

function getDerivedProps(e, r) {
    return 'function' == typeof e ? e(r) : e;
}
function getProcessedProps(e, r, t) {
    return 'function' == typeof e ? e(r, t) : r;
}
function getDefaultClassNameIterable(e, r, t) {
    return e ? 'function' == typeof e ? e(r, t) : new Set(e) : null;
}
function getCoreProps(e) {
    return Object.fromEntries(Object.entries(e).filter(([e])=>isValidStyleProperty(e) || o.has(e)));
}
function removeCoreProps(e) {
    return Object.fromEntries(Object.entries(e).filter(([e])=>!isValidStyleProperty(e) && !o.has(e)));
}
let o = new Set([
    'as',
    'component',
    'render',
    'swanStyle',
    'className',
    'children',
    '__dangerouslySuppressWarning'
]);
function shouldFilterPropKeyFactory(e) {
    if (!e) return ()=>false;
    let r = iterToSet(e);
    return function(e) {
        return r.has(e);
    };
}
function filterProps(t, n, s) {
    let i = shouldFilterPropKeyFactory(n), l = Object.entries(t).filter(([e])=>!(isValidStyleProperty(e) || o.has(e) || 'htmlSize' === e || i(e))), u = className(t.className, s ? Array.from(s) : null);
    u && l.push([
        'className',
        u
    ]);
    let p = t.htmlSize;
    return void 0 !== p && l.push([
        'size',
        p
    ]), Object.fromEntries(l);
}
function wrap(e, r, t) {
    return (n)=>e(r, t, n);
}
function getProps(e, r, t) {
    let { derivedProps: o, processProps: s, classNames: i, wrapRoot: l, wrapChildren: u } = r || {}, p = getDerivedProps(o, e), c = getProcessedProps(s, e, p), f = getDefaultClassNameIterable(i, c, p), a = processStyleProps(c, f), m = filterProps(c, t, a);
    return {
        processedProps: c,
        props: m,
        wrapRoot: l ? wrap(l, c, p) : null,
        children: u ? u(c, p, c.children) : c.children
    };
}

export { filterProps, getCoreProps, getDefaultClassNameIterable, getDerivedProps, getProcessedProps, getProps, removeCoreProps, wrap };
